import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { InvoiceStateFlowProps } from "models/propTypes/invoicePropTypes";
//#endregion
//#region components
import { LinearStateFlowContainer, useMountedState } from "components/common";
import { useInvoiceService } from "serviceHooks";
//#endregion

const InvoiceStateFlow: React.FC<InvoiceStateFlowProps> = (props) => {
  const invoiceService = useInvoiceService();
  const { getMounted } = useMountedState();
  const { invoiceId, status } = props;

  const [states, setStates] = React.useState<WintSuperkollAPIModel.EntityStateLog[]>();

  React.useEffect(() => {
    invoiceService.getStateLogs(invoiceId).then((items) => {
      if (getMounted()) {
        if (status === WintSuperkollAPIModel.InvoicePaymentState.Paid) {
          setStates(items.filter((e) => e.date != null));
        } else {
          setStates(items);
        }
      }
    });
  }, [invoiceId]);

  return <>{states && <LinearStateFlowContainer steps={states} translationKey={"Invoice.StateFlowState"} />}</>;
};

export default InvoiceStateFlow;
